<template>
    <div>
        <!--         <DialogoEliminar ref="refDialogoEliminar" titulo="Eliminar" :tipo="tipo" @refreshItems="actualizarItems" /> -->
        <v-dialog v-model="isActive" persistent :fullscreen="$vuetify.breakpoint.mobile"
            transition="dialog-bottom-transition" scrollable>
            <!-- :fullscreen="$vuetify.breakpoint.mobile" -->
            <v-card>
                <v-app-bar elevation="0" color="white">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="tab == 0" v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                @keydown.esc="cerrarDialogo">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-btn v-else-if="tab !== 0" v-bind="attrs" v-on="on" icon @click="back">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Cerrar</span>
                    </v-tooltip>
                    <v-toolbar-title>{{ itemGrid.titulo }}</v-toolbar-title>
                    <v-avatar class="ml-2 white--text" color="primary lighten-1" light size="28" v-if="(tab == 0)">
                        {{ Object.keys(itemsContacto).length }}
                    </v-avatar>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom v-if="(tab == 0)">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary lighten-1" class="pa-5" v-bind="attrs" rounded v-on="on" elevation="3"
                                small @click="nuevoItem()">
                                <v-icon class="mr-2">{{ itemGrid.icon_btn }}</v-icon>Nuevo {{ itemGrid.tipo }}
                            </v-btn>
                        </template>
                        <span>Nuevo</span>
                    </v-tooltip>
                </v-app-bar>
                <v-card-text v-if="tab == 0" :key="componentKey">
                    <v-data-table :headers="cabecera" :key="componentKey" :items="itemsContacto"
                        class="ma-2 elevation-2 rounded-0" hide-default-footer disable-pagination>
                        <template v-slot:item.actions="{ item }">
                            <div class="d-flex flex-row justify-center">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" fab small @click="editarItem(item)" outlined
                                            class="mx-1 pa-4" color="primary">
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" fab small v-on="on" @click="eliminarItem(item)"
                                            v-if="Object.keys(itemsContacto).length > 1" color="error" outlined
                                            class="pa-4">
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                </v-tooltip>
                            </div>
                        </template>
                        <template v-slot:item.recibecorreo="{ item }">
                            <v-row class="mt-1 justify-center align-center">
                                <v-checkbox v-model="item.recibecorreo" :true-value=1 :false-value=0
                                    disabled></v-checkbox>
                            </v-row>
                        </template>
                        <template v-slot:item.recibeemail="{ item }">
                            <v-row class="mt-1 justify-center align-center">
                                <v-checkbox v-model="item.recibeemail" :true-value=1 :false-value=0
                                    disabled></v-checkbox>
                            </v-row>
                        </template>
                        <template v-slot:item.recibellamada="{ item }">
                            <v-row class="mt-1 justify-center align-center">
                                <v-checkbox v-model="item.recibellamada" :true-value=1 :false-value=0
                                    disabled></v-checkbox>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-text v-if="tab == 1">
                    <FormEditarDomicilios v-if="itemGrid.tipo == 'domicilio'" :btn_label="this.label"
                        @refreshItems="actualizarItems" @volver="cambiarTab"
                        :tipoContactoFiltro="this.itemsContacto.map(item => item.destipcontacto)" />
                    <FormEditarMail v-if="itemGrid.tipo == 'mail'" :btn_label="this.label"
                        @refreshItems="actualizarItems"
                        :tipoContactoFiltro="this.itemsContacto.map(item => item.destipcontacto)" />
                    <FormEditarTelefono v-if="itemGrid.tipo == 'telefono'" :btn_label="this.label"
                        @refreshItems="actualizarItems"
                        :tipoContactoFiltro="this.itemsContacto.map(item => item.destipcontacto)" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import DialogoEliminar from '@/components/dialogos/DialogoEliminar'
import DialogoCardExp from '@/components/dialogos/DialogoCard'

import FormEditarDomicilios from '@/components/forms/FormEditarDomicilios.vue'
import FormEditarMail from '@/components/forms/FormEditarMail.vue'
import FormEditarTelefono from '@/components/forms/FormEditarTelefono.vue'
import ExpansionPanelGen from '@/components/panels/ExpansionPanelGen.vue'


import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        ExpansionPanelGen,
        FormEditarDomicilios,
        FormEditarMail,
        FormEditarTelefono,

        DialogoEliminar,
        DialogoCardExp,
    },
    props: ['itemsContacto', 'itemGrid', 'cabecera'],
    name: 'DialogoEditar',

    mounted() {
        switch (this.itemGrid.tipo) {
            case "domicilio":
                this.hayPrincipal = this.itemsContacto.some(item => item.recibecorreo == 1);
                break;
            case "telefono":
                this.hayPrincipal = this.itemsContacto.some(item => item.recibellamada == 1);
                break;
            case "mail":
                this.hayPrincipal = this.itemsContacto.some(item => item.recibeemail == 1);
                break;
            default:
                break;
        }
    },

    data() {
        return {
            isActive: false,

            /*
            itemsConyuge: [
                { title: 'Datos de conyuge/conviviente', icon: 'mdi-account-outline', component: 'FormFamiliar', color: 'primary' },
                { title: 'DNI de conyuge/conviviente (frente y dorso)', icon: 'mdi-card-account-details-outline', component: 'InputArchivos', color: 'primary' }, 
                { title: 'Certificado de matrimonio/convivencia/concubinato', icon: 'mdi-file-document-multiple-outline', component: 'InputArchivos', color: 'primary' }, 
            ],
            */


            //Grid
            checkbox1: 1,
            tab: 0,
            title: '',
            accion: '',

            label: '',
            tipo: '',
            componentKey: 0,

            //DialogoEditar
            titulo: '',

            hayPrincipal: false,


            itemSeleccionado: {},

        }
    },
    computed: {
        ...mapGetters(['telefono', 'email', 'domicilio']),
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('itemEdit', ['itemSelected']),
    },
    methods: {

        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),
        ...mapActions('itemEdit', ['vaciarItem', 'cargarItem']),
        ...mapActions(['refreshData']),

        forceRerender() {
            this.componentKey += 1;
        },

        cerrarDialogo() {
            this.tab = 0
            //se vacia itemEdit al cerrar el dialogo
            this.vaciarItem()
            this.isActive = false
        },
        abrirDialog() {
            this.isActive = true
        },
        actualizarItems() {
            //refresca los Items
            this.refreshData()
            this.cerrarDialogo()
        },
        back() {
            this.tab = 0
            this.label = ''
            this.forceRerender()
            this.vaciarItem()
        },
        nuevoItem() {
            this.label = `Nuevo ${this.itemGrid.tipo}`
            this.accion = 'A'
            this.tab = 1
            /*
            this.vaciarItem()
            */
        },
        editarItem(item) {
            this.label = `Editar ${this.itemGrid.tipo}`
            this.itemSeleccionado = item
            this.cargarItem(item)
            this.tab = 1
        },
        eliminarItem(item) {
            this.tipo = this.itemGrid.tipo
            if (this.tipo != 'familiar') {
                if (item.recibeemail == 0 || item.recibecorreo == 0 || item.recibellamada == 0) {
                    console.log('se elimina porque no esta marcado como principal')
                    this.cargarItem(item)
                    this.$refs.refDialogoEliminar.lanzar()
                } else {
                    this.showSnack({
                        message: 'No puede eliminar porque esta marcado como principal',
                        type: '400'
                    })
                }
            } else {
                this.cargarItem(item)
                this.$refs.refDialogoEliminar.lanzar()
            }
        },
        cambiarTab() {
            this.tab = 0
            this.forceRerender()
        },

        selectId(value) {
            console.log('familiar modificado' + value)


        },
    }

}

</script>